// eslint-disable-next-line jira/filename-case
import React from 'react';
import { useLegacySearchTheme } from '@atlaskit/navigation-system/theming/use-legacy-search-theme';
import { ProductSearchInputSkeletonInteractive } from '@atlassian/product-search-dialog/product-search-input-interactive-skeleton';

import { useTheme as useThemeDI } from '@jira/navigation-apps__atlassian-navigation-theme/src/main.tsx';
import type { UseThemeType } from '@jira/navigation-apps__atlassian-navigation-theme/src/types.tsx';

type Props = {
	useTheme?: UseThemeType;
	placeholder?: string;
};

export const SkeletonInteractive = ({
	useTheme = useThemeDI,
	placeholder,
}: Props): React.JSX.Element => {
	/**
	 * The nav3 custom theme object
	 */

	useTheme();
	/**
	 * A nav4 search theme that works with the nav3 theming API
	 */
	const newTheme = useLegacySearchTheme();

	return (
		<ProductSearchInputSkeletonInteractive
			shouldFillContainer
			theme={newTheme}
			placeholder={placeholder || ''}
			stickySearchEnabled
		/>
	);
};
